import {Dialog} from "primereact/dialog";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import "./CoordinationDialog.css";
import {Tooltip} from "primereact/tooltip";
import {Button} from "primereact/button";
import {getCoordinations, notifyTsos} from "../../../api/Coordination/coordination-service";
import {showSuccess} from "../../../api/notification/ToastManager";
import {useEffect, useState} from "react";

const CoordinationDialog = ({isCoordinationPopupVisible, dcId, hidePopup, marketNodeData}) => {
    const [isButtonNotifyTsosLoading, setIsButtonNotifyTsosLoading] = useState(false);
    const [coordinationHeaderTitle, setCoordinationHeaderTitle] = useState("");
    const [coordinationData, setcoordinationData] = useState(null);
    const [refreshIcon, setRefreshIcon] = useState("pi pi-sync");

    const statusBody = (r) => {
        return (<i className="pi pi-circle-fill" data-pr-tooltip={r.status.name}
                   style={{'fontSize': '.8em', 'color': r.status.color}}>
                <Tooltip target=".pi"/></i>
        );
    }
    const formatNote = (note) => {
        const [textPart, datePart] = note.split(" at ");
        if (!datePart) return note;
        const dateObj = new Date(datePart);

        if (isNaN(dateObj)) {
            return note;
        }
        const formattedDate = dateObj.toLocaleString([], {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false,
        });

        return `${textPart} at ${formattedDate}`;
    };
    const retreiveCoordinations = () => {
        setRefreshIcon("pi pi-spin pi-sync");
        if (marketNodeData !== null && marketNodeData !== undefined) {
            setCoordinationHeaderTitle("Coordination details for " + marketNodeData.name)
            let coordinations = [];
            getCoordinations(marketNodeData?.id).then(r => {
                r.content.forEach(coo => {
                    let marketNode = "";
                    if (coo.firstMarketNode?.marketNode?.name === marketNodeData.name) {
                        marketNode = coo.secondMarketNode?.marketNode;
                    } else {
                        marketNode = coo.firstMarketNode?.marketNode;
                    }
                    coordinations.push({
                        "id": coo.id,
                        "coordinator": marketNode,
                        "status": coo.status,
                        "note": formatNote(coo.note)
                    })
                })
                setcoordinationData(coordinations);
                setRefreshIcon("pi pi-sync");

            })
        }
    }

    useEffect(() => {
        if (isCoordinationPopupVisible) {
            retreiveCoordinations();
        }
    }, [isCoordinationPopupVisible]);

    function notifyTsosCommand() {
        setIsButtonNotifyTsosLoading(true);
        var coordinators = coordinationData.filter(coordination => {
            return coordination.status.code === "VALIDATION_FAILED"
        })
            .map(co => {
                return {"coordinationId": co.id, "fixByMn": co.coordinator.name, "dcMnToBeNotified": co.coordinator.id,}
            })
        notifyTsos({"dcId": dcId, "coordinationDetailsParams": coordinators}).then(r => {
            setIsButtonNotifyTsosLoading(false);
            if (r.status === 200) {
                hidePopup();
                showSuccess("Success", "TSOs successfully notified !");
            }
        })
    }

    return (
        <Dialog header={coordinationHeaderTitle} headerClassName="dialog-header-centered" onHide={hidePopup}
                modal visible={isCoordinationPopupVisible}
                style={{width: '50vw'}}>
            <DataTable
                className={coordinationData == null ? 'data-table-container datatable-centered datatable-loading-style' : 'datatable-centered datatable-loading-style'}
                value={coordinationData} loading={coordinationData === null}>
                <Column field="coordinator.name" header="Coordinator" bodyClassName="text-center"></Column>
                <Column header="Validation status" bodyClassName="text-center" body={statusBody}></Column>
                <Column
                    field="note"
                    header="Description"
                    bodyClassName="text-center"
                    body={(rowData) => (
                        <span style={{color: '#6c757d', fontSize: '0.85rem'}}>
      {rowData.note}
    </span>
                    )}
                />
            </DataTable>
            {coordinationData?.some((c) => c.status.code === 'VALIDATION_FAILED') && (
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        backgroundColor: '#f8efdd',
                        border: '1px solid #ffeeba',
                        borderRadius: 8,
                        padding: '12px 16px',
                        marginTop: 20,
                        color: '#a37513',
                        fontSize: '0.95rem',
                    }}
                >
                    <i className="pi pi-exclamation-triangle" style={{fontSize: 20, marginRight: 12}} aria-hidden/>
                    <div>
                        If you are confident that your data is accurate and that it is the coordinator’s
                        responsibility to make the necessary corrections, please click the <strong>Notify TSOs to
                        correct data</strong> button to inform them.
                    </div>
                </div>
            )}
            <div style={{display: 'flex', justifyContent: 'right', paddingTop: '20px'}}>
                {coordinationData?.filter(c => c.status.code === 'VALIDATION_FAILED').length > 0 ?
                    <Button className="notifyBtnStyle" loading={isButtonNotifyTsosLoading}
                            onClick={notifyTsosCommand}> Notify TSOs to correct data </Button> : null}
                <Button className="notifyBtnStyle" icon={refreshIcon} onClick={retreiveCoordinations}/>

            </div>
        </Dialog>)
}

export default CoordinationDialog;